var React = require('react');

function ClockIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M82,156.3c41,0,74.3-33.3,74.3-74.3C156.3,41,123,7.6,82,7.6C41,7.6,7.7,41,7.7,82C7.7,122.9,41,156.3,82,156.3\n\tz M82,17.8c35.4,0,64.2,28.8,64.2,64.2s-28.8,64.2-64.2,64.2c-35.4,0-64.2-28.8-64.2-64.2S46.6,17.8,82,17.8z M78.5,85.1l26.6,29.2\n\tc0,0,3.4,3.2,6.5,0.3c3.1-2.9,0.3-6.5,0.3-6.5L86.6,80.2V27c0,0-0.3-4.7-4.6-4.6c-4.2,0-4.7,4.6-4.7,4.6v54.3\n\tC77.1,83.3,78.5,85.1,78.5,85.1z"}));
}

ClockIcon.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 164 163.9","style":{"enableBackground":"new 0 0 164 163.9"},"xmlSpace":"preserve"};

module.exports = ClockIcon;

ClockIcon.default = ClockIcon;
